export default {
    categories: {
        INTERNAL_BUTTON_NAVIGATION: 'Button Navigation (Internal)',
        FORWARD_BUTTON_NAVIGATION: 'Button Navigation (Internal, Forward)',
        BACKWARD_BUTTON_NAVIGATION: 'Button Navigation (Internal, Backward)',
        INTERNAL_LINK_NAVIGATION: 'Link Navigation (Internal)',
        EXTERNAL_LINK_NAVIGATION: 'Link Navigation (External)'
    },
    actions: {
        CLICK_SOLERA_LOGO: 'Click Solera Logo',
        CLICK_DIRECT_HIT_SUBMIT_BUTTON: 'Click "Submit" Button on "Direct Hit Account" Screen',
        CLICK_DIRECT_HIT_BACK_BUTTON: 'Click "Back" Button on "Direct Hit Account" Screen',
        CLICK_FACEBOOK_LINK: 'Click "Facebook" Link',
        CLICK_LINKEDIN_LINK: 'Click "LinkedIn" Link',
        CLICK_TWITTER_LINK: 'Click "Twitter" Link',
        CLICK_WHY_JOIN_LINK: 'Click "Why Join" Link',
        CLICK_REWARDS_LINK: 'Click "Rewards" Link',
        CLICK_FAQ_LINK: 'Click "Faq" Link',
        CLICK_SECURITY_AND_PRIVACY_LINK: 'Click "Security & Privacy" Link',
        CLICK_TERMS_AND_CONDITIONS_LINK: 'Click "Rewards Terms & Conditions" Link',
        CLICK_CONTACT_US_LINK: 'Click "Contact Us" Link'
    }
};


// WEBPACK FOOTER //
// ./src/utils/googleAnalyticsKeys.js